
import Vue from "vue";

export default Vue.extend({
  name: 'Login',
  data() {
    return {
      username: '', // 默认填充用户名
      password: '' // 密码默认空
    }
  },
  methods: {
    handleLogin() {
      // 这里可以写登录逻辑（比如请求接口）
      console.log('登录信息：', {
        username: this.username,
        password: this.password
      })
      // 示例：简单校验
      if (!this.username || !this.password) {
        alert('请填写用户名和密码')
      } else {
        alert('登录请求已发送')
      }
    }
  }
})

